import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";
import MerchandisingListing from "app/pages/Merchandising/MerchandisingListing/MerchandisingListing";
import { forceCheck } from "react-lazyload";
import { useLocation } from "react-router-dom";
import { acceptCookyPolicy } from "app/pages/.shared/CookiePolicyFooter/cookiePolicyActionCreators";
import { clearProduct } from "app/pages/Listing/productActionCreators";
import {
	getMerchandisingMedias,
	getMerchandisingTopicsFilterValuesFromMerchCode,
	getVisibleProductsOfMerchandising,
} from "app/pages/Merchandising/merchandisingSelector";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import { fetchMerchandising } from "app/pages/Merchandising/merchandisingActionCreators";
import { parseQueries } from "app/utils/routerUtils";
import { getFallbackRedirectUrl, getPartnerListingSEO } from "app/reducers/partnerSelector";
import { resetAllProductsFilter } from "app/pages/Listing/ProductFilters/productsFilterActionCreators";
import AppGlobalsContext from "app/AppGlobalsContext";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import { mapProductToTag } from "app/utils/analytics-store-mapper";
import { resetAllSDPProductsFilter } from "app/pages/SmartDP/Listing/SmartDPFilters/smartDPProductsFilterActionCreators";
import { updateSDPFormDestination } from "app/pages/Booking/bookingActionCreators";

const MerchandisingContainer = props => {
	const {
		acceptCookyPolicy,
		fetchMerchandising,
		resetAllProductsFilter,
		updateSDPFormDestination,
		destinations = [],
	} = props;

	const [loading, setLoading] = useState(true);
	const location = useLocation();

	const { track } = useAnalytics();

	const { shop, productsVisibility, partnerCode } = useContext(AppGlobalsContext);

	useEffect(() => {
		resetAllProductsFilter();

		const queries = parseQueries(location.search);

		fetchMerchandising({
			code: queries.code,
			shop,
			productsVisibility,
			partnerCode,
		}).then(response => {
			const merchandising = get(response, "data.merchandising", {});
			const products = get(response, "data.products", []);
			setLoading(false);

			const merchDestinationResort = merchandising?.destinationFilterValues
				? destinations.find(
						destination =>
							destination.label === merchandising?.destinationFilterValues[0]
				  )
				: undefined;

			const hideSmartDPForm = merchandising?.displayOptions?.smartDP?.hideSmartDPForm;

			if (
				!hideSmartDPForm &&
				merchandising?.destinationFilterValues?.length === 1 &&
				merchDestinationResort
			) {
				updateSDPFormDestination({
					code: merchDestinationResort.code.toString(),
					label: merchDestinationResort.label,
				});
			} else {
				// vider la DestinationResort dans le cas ou la distination n'est pas requetable ou qu'il y'a plusieurs destination filters value
				updateSDPFormDestination();
			}
			track("merchandising_product_list", {
				code: merchandising.code,
				label: merchandising.label,
				position: String(merchandising.position),
				indexCarousel: String(merchandising.headerIndex),
				products: products
					.slice(0, 3)
					.map(mapProductToTag)
					.map((product, position) => ({ ...product, position })),
				merchCode: merchandising.code,
				isMerchMedia: String(!isEmpty(merchandising.media)),
				smartDP: !isEmpty(merchandising.displayOptions?.smartDP)
					? {
							title: merchandising.displayOptions?.smartDP?.merchandisingTitleDesktop,
							subtitle:
								merchandising.displayOptions?.smartDP?.merchandisingSubtitleDesktop,
					  }
					: undefined,
			});

			forceCheck();
		});

		return () => {
			acceptCookyPolicy();
		};
	}, [location, destinations]);

	return <MerchandisingListing {...props} loading={loading} />;
};

MerchandisingContainer.propTypes = {
	clearProduct: PropTypes.func,
	acceptCookyPolicy: PropTypes.func,
	resetAllProductsFilter: PropTypes.func,
	partnerCode: PropTypes.string,
	resolution: PropTypes.string,
	fetchMerchandising: PropTypes.func,
	listingSEO: PropTypes.object,
	updateSDPFormDestination: PropTypes.func,
	destinations: PropTypes.array,
};

const mapStateToProps = state => {
	return {
		activeFilter: state.merchandising.activeFilter,
		resolution: state.resolution,
		partnerCode: state.partner.code,
		merchandisingMedias: getMerchandisingMedias(state),
		currentMerchandising: state.merchandising.current,
		productsOfMerchandising: getVisibleProductsOfMerchandising(state),
		merchandisings: state.merchandising.lightList,
		merchandisingTopics: getMerchandisingTopicsFilterValuesFromMerchCode(state),
		fallbackRedirectUrl: getFallbackRedirectUrl(state),
		showSmartDPOnRootUrl: state.partner.showSmartDPOnRootUrl,
		listingSEO: getPartnerListingSEO(state),
		destinations: state.smartDP.destinations,
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			clearProduct,
			acceptCookyPolicy,
			fetchMerchandising,
			resetAllProductsFilter,
			resetAllSDPProductsFilter,
			updateSDPFormDestination,
		},
		dispatch
	);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(MerchandisingContainer);
